var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsUpdate',{attrs:{"modelName":_vm.modelName,"id":_vm.$route.params.id,"label":_vm.label,"fields":_vm._fields,"primary":_vm.pageSetting.primary,"secondary":_vm.pageSetting.secondary,"titleKey":"name"}})}
var staticRenderFns = []

export { render, staticRenderFns }